import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {isUserAuthenticated} from '../app/slices/UserSlice';

const PrivateRoute = ({children}) => {
  //console.log('in private route: ' + (new Date()).toLocaleTimeString());
  const location = useLocation();

  const isAuthenticated = useSelector(isUserAuthenticated);
  return isAuthenticated ? children : <Navigate to={{ pathname: "/login", state: {from: location}}}/>

};

/*
const PrivateRoute = ({component: Component, ...rest}) => {
  //console.log('in private route: ' + (new Date()).toLocaleTimeString());
  const location = useLocation();

  const isAuthenticated = useSelector(isUserAuthenticated);
  //TODO: this is where a check on isAuthenticated could check the expiration date
  return (
    <Route {...rest}>
      {isAuthenticated ?
        <Component />
        :
        <Navigate to={{ pathname: "/login", state: {from: location}}}/>
      }
    </Route>
  );

};
*/
export default PrivateRoute;
